import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import CXonePopupCallback from "./Pages/CXonePopupCallback";

const root = ReactDOM.createRoot(document.getElementById("root"));
// This is temporary fix until cxone sets /#/cxone-popup-callback redirect url
const isCallbackUrl = window.location.pathname === "/cxone-popup-callback";

root.render(
  <React.StrictMode>
    {isCallbackUrl ? <CXonePopupCallback /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
